import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { TableContext } from '../../contexts/TableContext';
import Link from '../Link';

const Pagination: React.FC = () => {
  const { t } = useTranslation();

  const { total, page, perPage, setPage } = useContext(TableContext);
  const totalPages = Math.ceil(total / perPage);

  return (
    <div className="row">
      <div className="col-sm-12 col-md-6">
        <div className="dataTables_info">
          {t('common.table.pagingText', {
            from: total === 0 ? 0 : page * perPage - (perPage - 1),
            to: page * perPage > total ? total : page * perPage,
            total,
          })}
        </div>
      </div>
      <div className="col-sm-12 col-md-6">
        <div className="dataTables_paginate paging_simple_numbers">
          <ul className="pagination">
            <li className={`paginate_button page-item previous ${page === 1 ? 'disabled' : ''}`}>
              <Link
                href="#"
                className="page-link"
                text="Previous"
                onClick={() => setPage(page - 1)}
              />
            </li>
            {page - 2 >= 1 && (
              <li className="paginate_button page-item disabled">
                <Link href="#" className="page-link" text="..." />
              </li>
            )}
            {page - 1 <= totalPages && page - 1 >= 1 && (
              <li className="paginate_button page-item">
                <Link
                  href="#"
                  className="page-link"
                  text={(page - 1).toString()}
                  onClick={() => setPage(page - 1)}
                />
              </li>
            )}
            <li className="paginate_button page-item active">
              <Link href="#" className="page-link" text={page.toString()} />
            </li>
            {page + 1 <= totalPages && (
              <li className="paginate_button page-item">
                <Link
                  href="#"
                  className="page-link"
                  text={(page + 1).toString()}
                  onClick={() => setPage(page + 1)}
                />
              </li>
            )}
            {page + 2 <= totalPages && (
              <li className="paginate_button page-item disabled">
                <Link href="#" className="page-link" text="..." />
              </li>
            )}
            <li
              className={`paginate_button page-item next ${page === totalPages || totalPages === 0 ? 'disabled' : ''}`}
            >
              <Link href="#" className="page-link" text="Next" onClick={() => setPage(page + 1)} />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
